// The unauthenticated landing screen: a single primary action that kicks off the
// OIDC Auth-Code + PKCE redirect to Keycloak.
import { login } from "../auth";

export function Login() {
  return (
    <div className="center-screen">
      <div className="card">
        <h1>IoTFW Service Login</h1>
        <p className="muted">
          Sign in with your operator account to manage users and roles.
        </p>
        <button
          type="button"
          className="btn btn-primary btn-large"
          onClick={() => {
            void login();
          }}
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
